import ApiService from './api.service';
import { useKiosksStore } from '@/stores/KiosksStore';

export const KioskService = {
  query(params) {
    return ApiService.query('kiosks', {
      params,
    });
  },
  get(slug) {
    return ApiService.get('kiosks', slug);
  },
  create(params) {
    return ApiService.post('kiosks', { kiosk: params }).then((response) => {
      this.updateKiosksStore();
      return response;
    });
  },
  update(slug, params) {
    return ApiService.update('kiosks', slug, { kiosk: params }).then((response) => {
      this.updateKiosksStore();
      return response;
    });
  },
  destroy(slug) {
    return ApiService.delete('kiosks', slug).then((response) => {
      this.updateKiosksStore();
      return response;
    });
  },
  multipartCreate(params, config) {
    return ApiService.post('kiosks', params, config).then((response) => {
      this.updateKiosksStore();
      return response;
    });
  },
  multipartEdit(slug, params, config) {
    return ApiService.update('kiosks', slug, params, config).then((response) => {
      this.updateKiosksStore();
      return response;
    });
  },
  duplicate(slug, params) {
    return ApiService.post(`kiosks/${slug}/duplicate`, params).then((response) => {
      this.updateKiosksStore();
      return response;
    });
  },
  syncFromProd(slug, params) {
    return ApiService.post(`kiosks/${slug}/sync_from_prod`, params).then((response) => {
      this.updateKiosksStore();
      return response;
    });
  },
  duplicateComponent(slug, componentId) {
    return ApiService.post(`kiosks/${slug}/duplicate_component`, { component_id: componentId }).then((response) => {
      this.updateKiosksStore();
      return response;
    });
  },
  formReports(extension = 'json') {
    return ApiService.get(`kiosks/form_reports.${extension}`);
  },
  superReport(extension = 'json') {
    return ApiService.downloadFile('kiosks/super_report');
  },
  kioskAnalytics(slug, params) {
    return ApiService.downloadFile(`kiosks/${slug}/kiosk_analytics`, { params });
  },
  bundleAnalytics(kiosk_id, bundle_id, params) {
    return ApiService.downloadFile(`kiosks/${kiosk_id}/bundles/${bundle_id}/bundle_analytics`, { params });
  },
  surveyAnalytics(slug, params) {
    return ApiService.query(`kiosks/${slug}/survey_analytics`, { params });
  },
  globalSurveyAnalytics(params) {
    return ApiService.query('kiosks/global_survey_analytics', { params });
  },
  updateKiosksStore() {
    const kiosksStore = useKiosksStore();
    kiosksStore.setKiosks();
  },
};

export default KioskService;
